import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
  heading: string;
  paragraph?: string | JSX.Element;
  btnText: string;
  btnApi: () => void;
  loading: boolean;
  secondBtnText?: string;
  isArchivePopup?: boolean;
  secondBtnApi?: () => void;
}

const ConfirmDelete = (props: PropsType) => {
  const {
    onClose,
    heading,
    paragraph,
    btnText,
    btnApi,
    loading,
    secondBtnText,
    secondBtnApi,
  } = props;

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper ">
        <div className="modal_header">
          <div className="title">
            <h3> {heading} </h3>
          </div>
        </div>

        <div className="modal_content">
          <p style={{ color: "#151718" }}>{paragraph} </p>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={secondBtnApi ? secondBtnApi : onCloseHandler}
          >
            {secondBtnText ? secondBtnText : "Cancel"}
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            // loading={loading}
          >
            {btnText}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default ConfirmDelete;
